import Image from "next/image"

import Pawprint from "../../assets/images/pawprint.png"
import Shadow from "../../assets/images/shadow.png"

export interface IHeroImageData {
  animal: string
  breed: string
  horizontal_image_alt_text: string
  horizontal_image_aspect_ratio: string
  horizontal_image_height: string
  horizontal_image_url: string
  horizontal_image_width: string
  portrait_image_alt_text: string
  portrait_image_aspect_ratio: string
  portrait_image_height: string
  portrait_image_url: string
  portrait_image_width: string
}
const BreedHeroImages = ({
  heroImageData,
}: {
  heroImageData?: IHeroImageData
}) => {
  return (
    <div className="relative h-full flex items-center justify-center">
      <div className="hidden md:flex items-center justify-center">
        <Image
          className="w-[318px] h-[424px] object-cover object-top rounded-2xl relative top-0 bottom-0 left-10"
          src={heroImageData?.portrait_image_url || ""}
          alt={heroImageData?.portrait_image_alt_text || "Dog"}
          height={424}
          width={318}
        />
        <Image
          className="relative  w-[317px] h-[212px] lg:w-[397px] lg:h-[265px] object-cover object-top rounded-2xl -left-10"
          src={heroImageData?.horizontal_image_url || ""}
          alt={heroImageData?.horizontal_image_alt_text || "Dog"}
          height={265}
          width={397}
        />
        <Image
          className="absolute w-[144px] h-[374px] lg:w-[180px] lg:h-[469px] right-32 lg:right-40"
          src={Pawprint.src}
          alt="paw print"
          height={469}
          width={180}
        />
        <Image
          className="absolute w-[42px] lg:w-[52px] h-8 lg:h-10 md:bottom-[245px] lg:bottom-[250px] md:-right-1 lg:right-4"
          src={Shadow.src}
          alt="paw print"
          height={40}
          width={52}
        />
      </div>
    </div>
  )
}

export default BreedHeroImages
